import { http, HttpResponse } from "msw";

import { DeploymentSsoProvider, SsoProvider } from "@protos/auth/v1/sso";
import { SsoType } from "@protos/common/v1/common";

import { TEST_ORG } from "./deployments";
import { SCM_GITHUB_USER } from "./scms";

export const GITHUB_SSO_PROVIDER: SsoProvider = {
  id: 1,
  name: "github",
  type: SsoType.GITHUB,
  displayName: "GitHub",
  emailDomain: "",
  baseUrl: "https://github.com",
};

export const GITLAB_SSO_PROVIDER: SsoProvider = {
  id: 2,
  name: "gitlab",
  type: SsoType.GITLAB,
  displayName: "GitLab",
  emailDomain: "",
  baseUrl: "https://gitlab.com",
};

export const GITHUB_DEPLOYMENT_SSO_PROVIDER: DeploymentSsoProvider = {
  id: 1,
  deploymentId: TEST_ORG.id,
  provider: GITHUB_SSO_PROVIDER,
  enabled: true,
  sourceId: SCM_GITHUB_USER.sourceId,
};

export const ssoProviderHandlersStatic = [
  http.get("*/api/auth/deployments/:id/providers/:providerType", () =>
    HttpResponse.json({ hasSso: false }, { status: 200 })
  ),
];
